/**
 * Zelus PWA 安装引导（自建，不调用 Qe 内部 popup）
 * - BIP 由 layout head（snippets/zelus-pwa-bip-capture，capture 阶段）缓存；
 *   bindUi 会采纳缓存并短轮询，避免与 OnBip 挂载竞态
 * - 支持 data-mount-target：CSS 选择器或页面 section id
 * - Theme Editor 隐藏/显示 / 改 Position 时强制重挂，避免残留与 Position 看似无效
 */
(function () {
  'use strict';

  /* 避免 Theme Editor 反复注入 script 时重复注册监听 */
  if (window.__zelusChallengePwaInstallBooted) {
    window.__zelusChallengePwaRemount && window.__zelusChallengePwaRemount();
    return;
  }
  window.__zelusChallengePwaInstallBooted = true;

  function isStandalone() {
    return (
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true
    );
  }

  function isIos() {
    return (
      /iphone|ipad|ipod/i.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
  }

  /**
   * 仅影响无 BIP 时的文案块；不虚构 prompt()
   * @returns {'ios'|'chrome'|'samsung'|'xiaomi'|'oppo'|'other'}
   */
  function detectAndroidFlavor() {
    if (isIos()) return 'ios';
    var ua = navigator.userAgent || '';
    var ual = ua.toLowerCase();
    /* 系统 WebView / 套壳优先归 other，避免误判为一键 Chrome */
    if (/; wv\)/i.test(ua) || /webview/i.test(ual)) return 'other';
    if (/xiaomi|miui|redmi|poco/i.test(ual)) return 'xiaomi';
    if (/oppo|heytap|coloros|realme|oneplus/i.test(ual)) return 'oppo';
    if (/samsung|sm-/i.test(ual)) return 'samsung';
    /* Chrome 且非 Edge/Opera/Firefox 抢 UA */
    if (/chrome|crios|crmo/i.test(ual) && !/edg|opr|opera|firefox|fxios/i.test(ual)) {
      return 'chrome';
    }
    return 'other';
  }

  function isAndroidChromeLike() {
    var f = detectAndroidFlavor();
    /* 仅真 Chrome / Samsung Internet 用 ⋮ 步骤；小米/OPPO 等走 other，避免误导 */
    return f === 'chrome' || f === 'samsung';
  }

  var GUIDE_QUERY = 'zelus_pwa_guide';

  function getChallengePathname(challengeUrl) {
    var raw = String(challengeUrl || '').trim();
    if (!raw) raw = '/pages/30-day-walking-challenge';
    var path = raw;
    if (/^https?:\/\//i.test(raw)) {
      try {
        path = new URL(raw).pathname;
      } catch (err) {
        path = raw;
      }
    }
    path = path.split('?')[0].split('#')[0];
    if (path.charAt(0) !== '/') path = '/' + path;
    return path.replace(/\/+$/, '') || '/';
  }

  function isOnChallengePage(challengeUrl) {
    var target = getChallengePathname(challengeUrl);
    var current = (window.location.pathname || '').replace(/\/+$/, '') || '/';
    if (current === target) return true;
    var pagesIdx = target.indexOf('/pages/');
    if (pagesIdx !== -1) {
      var handlePath = target.slice(pagesIdx);
      if (current.indexOf(handlePath) !== -1) return true;
    }
    return current.length >= target.length && current.slice(-target.length) === target;
  }

  function buildGuideRedirectUrl(challengeUrl) {
    var path = getChallengePathname(challengeUrl);
    var url;
    if (/^https?:\/\//i.test(String(challengeUrl || '').trim())) {
      try {
        url = new URL(challengeUrl);
      } catch (err) {
        url = new URL(path, window.location.origin);
      }
    } else {
      var root =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      root = String(root);
      if (root !== '/' && path.indexOf(root.replace(/\/+$/, '')) !== 0) {
        path = root.replace(/\/+$/, '') + path;
      }
      url = new URL(path, window.location.origin);
    }
    url.searchParams.set(GUIDE_QUERY, '1');
    return url.pathname + url.search + url.hash;
  }

  function shouldAutoOpenGuide() {
    try {
      return new URLSearchParams(window.location.search).get(GUIDE_QUERY) === '1';
    } catch (err) {
      return new RegExp('[?&]' + GUIDE_QUERY + '=1(?:&|$)').test(window.location.search || '');
    }
  }

  function clearAutoOpenParam() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has(GUIDE_QUERY)) return;
      url.searchParams.delete(GUIDE_QUERY);
      var next = url.pathname + url.search + url.hash;
      window.history.replaceState({}, '', next);
    } catch (err) {
      /* ignore */
    }
  }

  function queryOne(sel) {
    if (!sel) return null;
    try {
      return document.querySelector(sel);
    } catch (err) {
      return null;
    }
  }

  /** 解析挂载点：选择器 / section id；兼容漏写 #/.、zh/zwc 笔误 */
  function resolveMountTarget(raw) {
    var value = (raw || '').trim();
    if (!value) return null;

    var tries = [value];

    if (value.indexOf('zh-pwa') !== -1) {
      tries.push(value.replace(/zh-pwa/g, 'zwc-pwa'));
    }

    if (!/^[.#\[]/.test(value) && value.indexOf(' ') === -1 && value.indexOf('>') === -1) {
      var id = value;
      if (id.indexOf('shopify-section-') === 0) {
        id = id.slice('shopify-section-'.length);
      }
      tries.push('#' + id);
      tries.push('.' + id);
      tries.push('#shopify-section-' + id);
      tries.push('#zwc-root-' + id);
      tries.push('[id="shopify-section-' + id + '"]');
      if (id.indexOf('zh-pwa') !== -1) {
        var fixed = id.replace(/zh-pwa/g, 'zwc-pwa');
        tries.push('#' + fixed);
        tries.push('.' + fixed);
      }
    }

    for (var i = 0; i < tries.length; i++) {
      var el = queryOne(tries[i]);
      if (el) return el;
    }
    return null;
  }

  function placeNode(node, target, position) {
    if (!target || !node) return false;
    var pos = (position || 'after').trim();

    try {
      switch (pos) {
        case 'before':
          target.insertAdjacentElement('beforebegin', node);
          break;
        case 'prepend':
          target.insertAdjacentElement('afterbegin', node);
          break;
        case 'append':
          target.insertAdjacentElement('beforeend', node);
          break;
        case 'after':
        default:
          target.insertAdjacentElement('afterend', node);
          break;
      }
      return true;
    } catch (err) {
      console.warn('[Zelus PWA] placeNode failed:', err);
      return false;
    }
  }

  function removeStaleRoots(sectionId, keepRoot) {
    if (!sectionId) return;
    document.querySelectorAll('[data-zelus-pwa-root][data-section-id="' + sectionId + '"]').forEach(function (el) {
      if (keepRoot && el === keepRoot) return;
      el.remove();
    });
  }

  function ensureStylesheetInHead(shell) {
    if (!shell) return;
    shell.querySelectorAll('link[href*="zelus-challenge-pwa-install"]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href) return;
      var existing = document.head.querySelector('link[href="' + href + '"]');
      if (existing) {
        if (link.parentNode) link.parentNode.removeChild(link);
        return;
      }
      document.head.appendChild(link);
    });
  }

  function hideEmptySectionShell(shell, root) {
    if (!shell || shell.contains(root)) return;
    shell.setAttribute('data-zelus-pwa-relocated', '1');
    shell.setAttribute('aria-hidden', 'true');
    shell.style.cssText =
      'position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;border:0!important;';
  }

  function mountRoot(root) {
    var raw = root.getAttribute('data-mount-target');
    if (!raw || !String(raw).trim()) return false;

    var sectionId = root.getAttribute('data-section-id');
    removeStaleRoots(sectionId, root);

    var target = resolveMountTarget(raw);
    if (!target) {
      console.warn(
        '[Zelus PWA] Mount target not found:',
        raw,
        '— Position ignored. Use #zwc-pwa-anchor or .zwc-pwa-anchor on the challenge page.'
      );
      return false;
    }

    var shell = root.closest('.shopify-section');
    ensureStylesheetInHead(shell);

    var position = root.getAttribute('data-mount-position') || 'after';
    if (placeNode(root, target, position)) {
      root.setAttribute('data-zelus-pwa-mounted', '1');
      root.setAttribute('data-zelus-pwa-mount-pos', position);
      hideEmptySectionShell(shell, root);
      return true;
    }
    return false;
  }

  function bindUi(root) {
    if (root.getAttribute('data-zelus-pwa-ui') === '1') return;
    root.setAttribute('data-zelus-pwa-ui', '1');

    var openBtn = root.querySelector('[data-zwc-pwa="open"]');
    var dialog =
      root.querySelector('[data-zwc-pwa="dialog"]') ||
      root.querySelector('dialog.zelus-pwa-guide') ||
      root.querySelector('dialog');
    if (!openBtn || !dialog) return;

    var closeBtns = dialog.querySelectorAll('[data-zwc-pwa="close"]');
    var primaryBtn = dialog.querySelector('[data-zwc-pwa="primary"]');
    var dismissBtn = dialog.querySelector('.zwc-pwa-dismiss');
    var hintBip = dialog.querySelector('[data-zwc-pwa="hint-bip"]');
    var hintDefault = dialog.querySelector('[data-zwc-pwa="hint-default"]');
    var panelIos = dialog.querySelector('[data-zwc-pwa="panel-ios"]');
    var stepsChrome = dialog.querySelector('[data-zwc-pwa="steps-android-chrome"]');
    var stepsOther = dialog.querySelector('[data-zwc-pwa="steps-android-other"]');
    var statusEl = dialog.querySelector('[data-zwc-pwa="status"]');

    var deferredPrompt = null;
    var labelInstall = openBtn.getAttribute('data-label-install') || 'Install app';
    var flavor = detectAndroidFlavor();

    function hideEntry() {
      root.hidden = true;
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      }
    }

    if (isStandalone()) {
      hideEntry();
      return;
    }

    function syncDeferredFromWindow() {
      if (!deferredPrompt && window.__zelusChallengeDeferredPrompt) {
        deferredPrompt = window.__zelusChallengeDeferredPrompt;
      }
    }

    function hideAllSteps() {
      if (panelIos) panelIos.hidden = true;
      if (stepsChrome) stepsChrome.hidden = true;
      if (stepsOther) stepsOther.hidden = true;
      dialog.classList.remove('zelus-pwa-guide--ios');
      if (dismissBtn) dismissBtn.hidden = false;
    }

    /**
     * 有 BIP → Install + hint-bip；无 BIP → 按 UA 显示添加桌面步骤 / iOS 示意图
     */
    function setPlatformSteps() {
      syncDeferredFromWindow();
      var hasBip = !!deferredPrompt;
      hideAllSteps();

      if (hintBip) hintBip.hidden = !hasBip;
      if (hintDefault) hintDefault.hidden = hasBip || flavor === 'ios';

      if (hasBip) return;

      if (flavor === 'ios') {
        dialog.classList.add('zelus-pwa-guide--ios');
        if (panelIos) panelIos.hidden = false;
        if (dismissBtn) dismissBtn.hidden = true;
        return;
      }

      if (hintDefault) hintDefault.hidden = false;

      if (isAndroidChromeLike()) {
        if (stepsChrome) stepsChrome.hidden = false;
        return;
      }

      if (stepsOther) stepsOther.hidden = false;
    }

    function updatePrimary() {
      syncDeferredFromWindow();
      if (primaryBtn) {
        if (deferredPrompt) {
          primaryBtn.hidden = false;
          primaryBtn.disabled = false;
          primaryBtn.textContent = labelInstall;
        } else {
          primaryBtn.hidden = true;
          primaryBtn.disabled = true;
        }
      }
      setPlatformSteps();
    }

    function setStatus(text) {
      if (statusEl) statusEl.textContent = text || '';
    }

    function adoptPrompt(e) {
      if (!e) return;
      deferredPrompt = e;
      window.__zelusChallengeDeferredPrompt = e;
      updatePrimary();
    }

    function openGuide() {
      syncDeferredFromWindow();
      updatePrimary();
      setStatus('');
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      /* iOS Safari 会把焦点落到第一个可聚焦控件（×），触发主题 *:focus-visible 描边 */
      requestAnimationFrame(function () {
        var closeX = dialog.querySelector('.zwc-pwa-close-x');
        if (closeX && document.activeElement === closeX) {
          closeX.blur();
        }
        try {
          if (!dialog.hasAttribute('tabindex')) {
            dialog.setAttribute('tabindex', '-1');
          }
          dialog.focus({ preventScroll: true });
        } catch (err) {
          /* ignore */
        }
      });
    }

    function closeGuide() {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    /* 唯一 UI 回调；BIP 监听只在 head snippet（capture），此处不再重复 addEventListener */
    window.__zelusChallengeOnBip = adoptPrompt;

    if (!window.__zelusChallengePwaUiBound) {
      window.__zelusChallengePwaUiBound = true;
      window.addEventListener('appinstalled', function () {
        window.__zelusChallengeDeferredPrompt = null;
        document.querySelectorAll('[data-zelus-pwa-root]').forEach(function (el) {
          el.hidden = true;
        });
      });
    }

    openBtn.addEventListener('click', function () {
      syncDeferredFromWindow();
      var challengeUrl =
        root.getAttribute('data-challenge-url') || '/pages/30-day-walking-challenge';
      /*
       * 无 BIP（含 iOS / 国产浏览器）：不在挑战页时先跳转再自动弹窗，
       * 以便「添加到主屏幕」钉住挑战页 URL。有 BIP 时仍可在当前页一键 Install（start_url 由 Manifest 决定）。
       */
      if (!deferredPrompt && !isOnChallengePage(challengeUrl)) {
        window.location.assign(buildGuideRedirectUrl(challengeUrl));
        return;
      }
      openGuide();
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeGuide();
      });
    });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeGuide();
    });

    if (primaryBtn) {
      primaryBtn.addEventListener('click', function () {
        syncDeferredFromWindow();
        if (!deferredPrompt) {
          setStatus(
            flavor === 'ios'
              ? 'Use Share → Add to Home Screen in Safari.'
              : 'Install is not ready yet. Use the steps above, or open this page in Chrome.'
          );
          return;
        }
        deferredPrompt.prompt();
        deferredPrompt.userChoice.finally(function () {
          deferredPrompt = null;
          window.__zelusChallengeDeferredPrompt = null;
          updatePrimary();
          closeGuide();
        });
      });
    }

    /* 采纳 head 已缓存的 BIP（避免 OnBip 挂上前事件已到达的竞态） */
    if (window.__zelusChallengeDeferredPrompt) {
      adoptPrompt(window.__zelusChallengeDeferredPrompt);
    } else {
      updatePrimary();
    }

    /* BIP 常在 SW/互动门槛后数秒才到：短轮询补一次 UI（全页只开一个） */
    if (!window.__zelusChallengeDeferredPrompt && !window.__zelusChallengeBipPoll) {
      window.__zelusChallengeBipPoll = true;
      var pollTries = 0;
      var pollId = setInterval(function () {
        pollTries += 1;
        if (window.__zelusChallengeDeferredPrompt) {
          if (typeof window.__zelusChallengeOnBip === 'function') {
            window.__zelusChallengeOnBip(window.__zelusChallengeDeferredPrompt);
          }
          window.__zelusChallengeBipPoll = false;
          clearInterval(pollId);
        } else if (pollTries >= 40) {
          window.__zelusChallengeBipPoll = false;
          clearInterval(pollId);
        }
      }, 500);
    }

    /* 从首页/其它页跳转过来：自动打开引导并清掉 query，避免刷新反复弹出 */
    if (shouldAutoOpenGuide()) {
      clearAutoOpenParam();
      requestAnimationFrame(function () {
        openGuide();
      });
    }
  }

  function initRoot(root, forceRemount) {
    if (!root) return;

    if (forceRemount || root.getAttribute('data-zelus-pwa-ready') !== '1') {
      mountRoot(root);
      root.setAttribute('data-zelus-pwa-ready', '1');
    }

    bindUi(root);
  }

  /** 每个 section id 只保留最新节点并强制按当前 Position 重挂 */
  function remountAll() {
    var byId = {};
    document.querySelectorAll('[data-zelus-pwa-root]').forEach(function (root) {
      var id = root.getAttribute('data-section-id') || root.id || '_anon';
      if (!byId[id]) byId[id] = [];
      byId[id].push(root);
    });

    Object.keys(byId).forEach(function (id) {
      var list = byId[id];
      var keep = list[list.length - 1];
      list.forEach(function (el) {
        if (el !== keep) el.remove();
      });
      keep.removeAttribute('data-zelus-pwa-ready');
      keep.removeAttribute('data-zelus-pwa-mounted');
      keep.removeAttribute('data-zelus-pwa-ui');
      initRoot(keep, true);
    });
  }

  window.__zelusChallengePwaRemount = remountAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', remountAll);
  } else {
    remountAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var scope = event.target;
    if (!scope || !scope.querySelectorAll) {
      remountAll();
      return;
    }
    var roots = scope.querySelectorAll('[data-zelus-pwa-root]');
    if (!roots.length) {
      remountAll();
      return;
    }
    roots.forEach(function (root) {
      var sectionId = root.getAttribute('data-section-id');
      removeStaleRoots(sectionId, root);
      root.removeAttribute('data-zelus-pwa-ready');
      root.removeAttribute('data-zelus-pwa-mounted');
      root.removeAttribute('data-zelus-pwa-ui');
      initRoot(root, true);
    });
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) return;
    removeStaleRoots(sectionId, null);
  });
})();
